import React from 'react';
import ReactJson from 'react-json-view';

import { MultiSelectIcon } from '@primer/octicons-react';

import { BUTTON_VARIANT } from '../../common/Button/Button';
import CloudOfflineIcon from '../../common/icons/CloudOfflineIcon';
import CollapsibleCardView from '../../common/CardView/CollapsibleCardView';
import ErrorLabel from '../../common/Labels/ErrorLabel';
import Icon from '../../common/icons/Icon';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';

import usePipelineData from '../PipelineDataContext';

import { formatLastRefreshDate } from '../../../utils/date_utils';
import { getThemeColor } from '../../../utils/theme-utils';

export const PipelineStatusDetailView = ({
  height = '300px',
}) => {
  const {
    deploymentStatus: data,
    deploymentStatusError: error,
    isPipelineDeploymentStatusLoading: loading,
    lastDeploymentStatusRefetch: lastRefreshTime,
    refetchDeploymentStatus: refetch,
  } = usePipelineData();

  return (
    <CollapsibleCardView
      headerText="Pipeline Status"
      quickActionText="Refresh"
      quickActionClick={refetch}
      quickActionVariant={BUTTON_VARIANT.DEFAULT}
      quickActionStyle={{
        backgroundColor: getThemeColor('brand'),
        color: getThemeColor('background'),
        '&:hover': {
          color: getThemeColor('brand'),
        },
      }}
      subHeaderLabel={lastRefreshTime ? `Last refreshed ${formatLastRefreshDate(lastRefreshTime)}` : undefined}
      icon={MultiSelectIcon}
    >
      {
        loading ? (
          <div
            className="p-4 flex-grow flex flex-col justify-center items-center border border-border-dark rounded"
            style={{ height }}
          >
            <LoadingSpinner animationKey="pipeline-status-loading-spinner" />
            <ErrorLabel className="mt-2">Loading&hellip;</ErrorLabel>
          </div>
        ) : (error || !data) ? (
          <div
            className="p-4 flex-grow flex flex-col justify-center items-center border border-border-dark rounded"
            style={{ height }}
          >
            <Icon
              fill={getThemeColor('brand')}
              icon={CloudOfflineIcon}
              size={64}
              useTailwindSizing
            />
            <ErrorLabel className="mt-2">Pipeline status unavailable at this time. Please click the Refresh button or try deploying your pipeline again.</ErrorLabel>
          </div>
        ) : (
          <div
            className="border border-border-dark rounded mt-2 py-2 px-4 overflow-y-scroll"
            style={{ height }}
          >
            <ReactJson
              src={data}
              indentWidth={2}
              name={false}
              displayDataTypes={false}
              displayArrayKey
              quotesOnKeys
            />
          </div>
        )
      }
    </CollapsibleCardView>
  )
}

export default PipelineStatusDetailView;
